module.exports = __webpack_public_path__ + "static/img/bg.f8d45547.png";